<template>
  <section class="container mx-auto py-6 md:pt-15 md:pb-10">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
      <template v-if="isLoading">
        <div v-for="i in 3" :key="i">
          <UtilsSkeletonLoading class="rounded-lg h-40 w-full mb-4 card-img" />
          <UtilsSkeletonLoading class="w-full h-14 mb-3" />
          <UtilsSkeletonLoading class="w-full h-12" />
        </div>
      </template>

      <template v-else>
        <ArticleCard
          v-for="product in ourProducts"
          :key="product.id"
          :with-logo="false"
          :title="product.attributes?.title"
          :desc="product.attributes?.description"
          :image-url="
            product.attributes?.banner?.background_image?.data?.attributes?.url
          "
          :slug="`/products/${product.attributes?.slug}`"
          :is-product="true"
        />
      </template>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const ourProducts = ref([])
const ourProductsMeta = ref([])

const getOurProducts = async () => {
  const { data, error, pending } = await useSuitmediaApiData(`/api/products`, {
    query: {
      'fields[0]': 'id',
      'fields[1]': 'title',
      'fields[2]': 'description',
      'fields[3]': 'slug',
      'fields[4]': 'content',
      'fields[5]': 'image',
      'populate[image][fields][0]': 'url',
      'populate[banner][populate]': 'background_image',
      'sort[0]': 'title:asc'
    }
  })

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Products does not exist`
    })
  }

  return data.value
}

const products = await getOurProducts()
ourProducts.value = products.data
ourProductsMeta.value = products.meta
</script>

<style lang="scss" scoped></style>
